var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillChargeType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 63,
    viewBox: "0 0 72 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 28.7607,
    width: 14.3804,
    height: 28.0761,
    fill: "#027BC7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6956,
    y: 20.5435,
    width: 14.3804,
    height: 36.2935,
    fill: "#E8EBF7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3911,
    y: 11.6414,
    width: 14.3804,
    height: 45.1957,
    fill: "#CCE5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0879,
    width: 14.3804,
    height: 56.837,
    fill: "#28345A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9351,
    y: 28.7607,
    width: 14.3804,
    height: 31.5,
    fill: "#28345A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0879,
    y: 26.7065,
    width: 21.913,
    height: 32.1848,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0671 63.0001C41.1085 63.0001 32.1846 54.1145 32.1846 43.1593C32.1846 32.204 41.1085 23.2827 52.0671 23.2827C63.0256 23.2827 71.902 32.204 71.902 43.1593C71.902 54.1145 62.978 62.9882 52.0671 62.9882V63.0001ZM51.3294 54.3762H45.9155C45.4396 54.3762 45.0469 53.9837 45.0469 53.5079C45.0469 53.0321 45.4396 52.6396 45.9155 52.6396H52.9714C55.3511 52.6396 57.3024 50.6888 57.3024 48.3098C57.3024 45.9308 55.3511 44.0276 52.9714 44.0276H51.5792C48.2476 44.0276 45.511 41.3036 45.511 37.9611C45.511 34.6186 48.1048 32.0731 51.3175 31.9423V29.0399C51.3175 28.5641 51.7101 28.1716 52.1861 28.1716C52.662 28.1716 53.0546 28.5641 53.0546 29.0399V31.9423H57.6951C58.171 31.9423 58.5637 32.3348 58.5637 32.8106C58.5637 33.2864 58.171 33.6789 57.6951 33.6789H51.5911C49.2114 33.6789 47.26 35.6297 47.26 37.9611C47.26 40.2926 49.2114 42.2909 51.5911 42.2909H52.9833C56.3148 42.2909 59.0515 44.9792 59.0515 48.3098C59.0515 51.6404 56.3624 54.2811 53.0784 54.3762V57.231C53.0784 57.7068 52.7334 58.0994 52.2098 58.0994C51.7339 58.0994 51.3413 57.7068 51.3413 57.231V54.3762H51.3294Z",
    fill: "#019EF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillChargeType);
export default __webpack_public_path__ + "static/media/billChargeType.fb17508ff06dbfa9c1f1de879358f49b.svg";
export { ForwardRef as ReactComponent };